/**
 * Leniwe doładowanie Sentry Session Replay — poza krytyczną ścieżką hydracji.
 *
 * replayIntegration został wyjęty z Sentry.init() (sentry.client.config.ts), bo
 * od inicjalizacji obserwuje i buforuje DOM (MutationObserver + snapshot), żeby
 * mieć nagranie gotowe do dołączenia do błędu (replaysOnErrorSampleRate). To
 * dokłada do TBT/INP dokładnie w oknie, w którym walczymy o Core Web Vitals.
 *
 * WAŻNE (bundling): `@sentry/nuxt` importujemy DYNAMICZNIE wewnątrz callbacku,
 * nie statycznie na górze modułu. Statyczny `import * as Sentry` powodował, że
 * bundler wciągał kod `@sentry-internal/replay` (+feedback +replay-canvas, ~94 KB)
 * do chunku ładowanego przy starcie. Dynamiczny import wydziela replay do osobnego
 * chunku. Rdzeń Sentry i tak żyje we wspólnym chunku (init w sentry.client.config),
 * więc nie dublujemy go.
 *
 * WAŻNE (CWV): ładowanie odroczone do PIERWSZEJ INTERAKCJI (onFirstInteraction),
 * nie onNuxtReady. onNuxtReady (idle po hydracji) odpala się W OKNIE pomiaru
 * Lighthouse, więc chunk replay (~94 KB, w większości nieużywany do momentu błędu)
 * doliczał się do TBT. Interakcja: Lighthouse/boty nie klikają → replay nie ładuje
 * się w oknie CWV, a realny user dostaje go po pierwszym scrollu/kliknięciu.
 *
 * Progi próbkowania (replaysOnErrorSampleRate itd.) pochodzą z opcji przekazanych
 * do Sentry.init() — leniwie dodana integracja je respektuje.
 *
 * Kompromis: błąd PRZED pierwszą interakcją nie będzie miał nagrania. W praktyce
 * interesujące błędy runtime pojawiają się przy interakcji (a przed nią i tak
 * łapie je error tracking, tylko bez replaya).
 */
export default defineNuxtPlugin(() => {
  // Replay tylko na produkcji — replaysOnErrorSampleRate na dev = 0, więc na
  // dev/QA integracja byłaby no-opem, a i tak kosztowałaby przy starcie.
  if (import.meta.env.MODE !== "production") return;

  // fallbackMs: null — bez timera (determinizm wyniku lab; replay to narzędzie
  // diagnostyczne, nie musi ładować się bez interakcji).
  onFirstInteraction(
    async () => {
      const Sentry = await import("@sentry/nuxt");
      const client = Sentry.getClient();
      if (!client) return;
      // Idempotencja — nie dodawaj drugi raz (np. HMR / podwójny mount).
      if (client.getIntegrationByName?.("Replay")) return;

      client.addIntegration(
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      );
    },
    { fallbackMs: null },
  );
});
